export const BRAND = {
  name: "HAK Sportcars - KFZ-Sachverständigenbüro",
  owner: "Athanasios Stefanidis",
  addressLine: "Oskar-Jäger-Str. 145, 50825 Köln",
  city: "Köln",
  colors: {
    red: "#E4161A", // brand red from logo
    navy: "#122543",
    steel: "#3E6B8E",
    sky: "#B9E3EC",
    offwhite: "#F5FBF7",
    black: "#0B0B0C",
  },
  assets: {
    logoDark: "https://customer-assets.emergentagent.com/job_40df9abe-5ef9-4399-9bf5-e29260eff13c/artifacts/5gx34yq2_gutachten_logo_dunkel.png",
    palette: "https://customer-assets.emergentagent.com/job_40df9abe-5ef9-4399-9bf5-e29260eff13c/artifacts/p42t20jh_image.png",
  },
};

export const CONTACT = {
  whatsappIntl: "+4915236373696",
  phoneIntl: "+4915236373696",
  email: "info@haksportcars-gutachten.de",
};

export const STEPS = [
  {
    id: 1,
    title: "Kontaktaufnahme",
    desc: "WhatsApp-Nachricht oder Anruf – wir reagieren sofort.",
    icon: "MessageSquare",
  },
  {
    id: 2,
    title: "Unfallbericht & Fotos",
    desc: "Schilder kurz den Schaden und schick uns Bilder – digital & einfach.",
    icon: "Camera",
  },
  {
    id: 3,
    title: "Terminvereinbarung",
    desc: "Vor Ort bei dir oder in unserem Büro – flexibel nach deinem Wunsch.",
    icon: "Calendar",
  },
  {
    id: 4,
    title: "Fahrzeugbegutachtung",
    desc: "Mit Kamera, Laptop, ggf. Hebebühne – präzise Analyse.",
    icon: "Search",
  },
  {
    id: 5,
    title: "Gutachten & Rücksprache",
    desc: "Wir erstellen dein Gutachten und senden es dir per E‑Mail – klar und verständlich erklärt.",
    icon: "FileCheck",
  },
  {
    id: 6,
    title: "Weiterleitung an Anwalt",
    desc: "Komplette Abwicklung mit Partneranwält:innen – du bleibst entspannt.",
    icon: "Scale",
  },
];

export const WHY_US = [
  "Führender KFZ Gutachter in Köln – bekannt durch HAK Sport Cars Sportwagenvermietung",
  "Erfahrung mit allen Fahrzeugtypen: PKW, LKW, Motorräder, Nutzfahrzeuge in Köln",
  "Spezialwissen bei Karosserieschäden, Strukturverzug, Hochwertfahrzeugen – Köln & Umgebung",
  "Erster WhatsApp-Service für Unfallgutachten in Köln – 60 Min Antwortzeit garantiert",
  "Modernste Robotik‑Vermessung in Köln für präzise Schadensbewertung",
  "Empfehlung Kölner Werkstätten – abgestimmt auf dein Fahrzeug und Budget",
  "Zugang zu regionalen Fahrzeugbörsen – bestes Angebot für Fahrzeugverkauf in Köln",
  "BVSKH-zertifiziert – geprüfte Qualität für KFZ-Gutachten in Köln und NRW",
];

export const LINKS = {
  whatsappLink:
    "https://wa.me/" +
    CONTACT.whatsappIntl.replace("+", "") +
    "?text=" +
    encodeURIComponent(
      "Hallo HAK, ich benötige ein Kfz‑Gutachten. Bitte um kurze Rückmeldung."
    ),
  telLink: "tel:" + CONTACT.phoneIntl,
  mailLink: "mailto:" + CONTACT.email,
};